import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, withModifiers as _withModifiers, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref, watch, onMounted, onBeforeUnmount, computed } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  props: /*@__PURE__*/_mergeModels({
    renderType: { default: 'if' },
    type: { default: 'center' },
    isCanClose: { type: Boolean, default: false },
    autoCloseTime: { default: 0 },
    isShowAnimate: { type: Boolean, default: true },
    closeFn: { type: Function, default: () => null },
    contentStyle: { default: () => ({}) }
  }, {
    "modelValue": { type: Boolean },
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {


const props = __props


const visible = _useModel<boolean>(__props, "modelValue")
const timer = ref<number | null>(null)

const type = computed(() => props.type || 'bottom')

const transitionName = computed(() => {
    if (!props.isShowAnimate) return ''
    switch (type.value) {
        case 'top': return 'popup-slide-top'
        case 'bottom': return 'popup-slide-bottom'
        case 'left': return 'popup-slide-left'
        case 'right': return 'popup-slide-right'
        case 'center': return 'popup-zoom-center'
        default: return ''
    }
})

function close() {
    visible.value = false
    props.closeFn && props.closeFn()
}

function handleMaskClick() {
    if (props.isCanClose) {
        close()
    }
}

watch(() => visible.value, val => {
    if (val && props.autoCloseTime) {
        if (timer.value) clearTimeout(timer.value)
        timer.value = window.setTimeout(() => {
            close()
        }, props.autoCloseTime)
    }
})

onMounted(() => {
    if (visible.value && props.autoCloseTime) {
        timer.value = window.setTimeout(() => {
            close()
        }, props.autoCloseTime)
    }
})

onBeforeUnmount(() => {
    if (timer.value) clearTimeout(timer.value)
})

return (_ctx: any,_cache: any) => {
  return (__props.renderType === 'show')
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _withDirectives(_createElementVNode("div", {
          class: "popup-mask",
          onClick: _withModifiers(handleMaskClick, ["self"])
        }, null, 512), [
          [_vShow, visible.value]
        ]),
        _createVNode(_Transition, {
          name: transitionName.value,
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", {
              class: _normalizeClass(['popup-content', type.value]),
              style: _normalizeStyle(__props.contentStyle)
            }, [
              _renderSlot(_ctx.$slots, "default")
            ], 6), [
              [_vShow, visible.value]
            ])
          ]),
          _: 3
        }, 8, ["name"])
      ], 64))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        (visible.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "popup-mask",
              onClick: _withModifiers(handleMaskClick, ["self"])
            }))
          : _createCommentVNode("", true),
        _createVNode(_Transition, {
          name: transitionName.value,
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (visible.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(['popup-content', type.value]),
                  style: _normalizeStyle(__props.contentStyle)
                }, [
                  _renderSlot(_ctx.$slots, "default")
                ], 6))
              : _createCommentVNode("", true)
          ]),
          _: 3
        }, 8, ["name"])
      ], 64))
}
}

})